import { MutationTree } from "vuex";
import {
    PortalSubtopicAsideWidgetState,
    IPortalSubtopicRelatedPagesWidgetModel,
    IPortalSubtopicContactWidgetModel
} from "@/apps/PortalSubtopicAsideWidget/models/PortalSubtopicAside-widget-state";

export default <MutationTree<PortalSubtopicAsideWidgetState>>{
    setRelatedPages(state: PortalSubtopicAsideWidgetState, relatedPages: IPortalSubtopicRelatedPagesWidgetModel[]) {
        state.relatedPages = relatedPages;
    },
    setContactInformation(state: PortalSubtopicAsideWidgetState, contactInformation: IPortalSubtopicContactWidgetModel[]) {
        state.contactInformation = contactInformation;
    },
    setSelectedFaculty(state: PortalSubtopicAsideWidgetState, selectedFaculty: string) {
        let relatedPages = state.relatedPages.filter((c: IPortalSubtopicRelatedPagesWidgetModel) => c.faculties.includes(selectedFaculty))
        let contact = state.contactInformation.find((c: IPortalSubtopicContactWidgetModel) => c.faculties.includes(selectedFaculty))

        // Only update when the faculty is present for this subtopic.
        // There is a change it is not when setting from the local storage.
        if (relatedPages.length != 0 || contact) {
            state.selectedFaculty = selectedFaculty
        } else {
            state.selectedFaculty = ''
        }

        // Update related page
        if (relatedPages.length != 0) {
            state.associatedRelatedPages = relatedPages
        }
        else {
            state.associatedRelatedPages = null
        }

        // Update contact info
        if (contact) {
            state.associatedContactInfo = contact
        }
        else {
            state.associatedContactInfo = null
        }
    }
}
